"use strict";

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './src/register/index';

const registrationApp = document.getElementById('registration_app');
if(!!registrationApp){
    render((
        <Router>
            <App />
        </Router>
    ), registrationApp);
}
